(function () {
 'use strict';
 function cartAddUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }
 function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
 if (!customElements.get('dox-purchase')) {
  customElements.define('dox-purchase', class extends HTMLElement {
   connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.idInput = this.form.querySelector('[name="id"]');
    this.qtyInput = this.form.querySelector('[data-dox-qty-field], [name="quantity"]');
    this.qtyDisplay = this.form.querySelector('[data-dox-qty-display]');
    if (this.qtyDisplay && this.qtyInput) {
     this.qtyDisplay.value = this.qtyInput.value;
     this.qtyDisplay.addEventListener('change', () => {
      var n = Math.max(1, parseInt(this.qtyDisplay.value, 10) || 1);
      this.qtyInput.value = n; this.qtyDisplay.value = n;
     });
    }
    this.bundleProp = this.form.querySelector('[data-dox-bundle-prop]');
    this.submitBtn = this.form.querySelector('[type="submit"]');
    this.btnText = this.submitBtn ? this.submitBtn.querySelector('[data-dox-btn-text]') : null;
    this.errorEl = this.querySelector('[data-dox-error]');
    this.priceTargets = document.querySelectorAll('[data-dox-selected-price]');
    this.compareTargets = document.querySelectorAll('[data-dox-selected-compare]');
    this.compareOn = this.getAttribute('data-compare-on') === 'true';
    this.savingsOn = this.getAttribute('data-savings-on') === 'true';
    this.saveWord = this.getAttribute('data-save-word') || 'Save';
    this.variants = this.readJSON('[data-dox-variants]', []);
    this.priceMap = this.readJSON('[data-dox-bundle-prices]', {});
    this.optionRadios = Array.prototype.slice.call(this.form.querySelectorAll('[data-option-position]'));
    this.optionRadios.forEach((r) => r.addEventListener('change', () => this.onVariantChange()));
    this.bundleRadios = Array.prototype.slice.call(this.form.querySelectorAll('[data-dox-bundle]'));
    this.bundleRadios.forEach((r) => r.addEventListener('change', () => this.onBundleChange()));
    this.querySelectorAll('[data-dox-qty-step]').forEach((b) => {
     b.addEventListener('click', () => {
      var step = parseInt(b.getAttribute('data-dox-qty-step'), 10) || 0;
      var v = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + step);
      this.qtyInput.value = v;
      if (this.qtyDisplay) this.qtyDisplay.value = v;
     });
    });
    document.addEventListener('dox:atc:trigger', () => {
     /* Let Horizon's product-form-component handle it. */
     if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(this.submitBtn || undefined);
    });
    this.onVariantChange();
    if (this.bundleRadios.length) this.onBundleChange();
   }
   readJSON(sel, fallback) {
    try {
     var el = this.querySelector(sel);
     return el ? JSON.parse(el.textContent) : fallback;
    } catch (e) { return fallback; }
   }
   currentOptionValues() {
    var byPos = {}, vals = [];
    this.optionRadios.forEach((r) => { if (r.checked) byPos[r.getAttribute('data-option-position')] = r.value; });
    Object.keys(byPos).sort().forEach((k) => vals.push(byPos[k]));
    return vals;
   }
   matchVariant() {
    var chosen = this.currentOptionValues();
    if (!this.variants.length) return null;
    if (!chosen.length) return this.variants[0];
    return this.variants.filter((v) => (v.options || []).length === chosen.length &&
     v.options.every((o, i) => o === chosen[i]))[0] || null;
   }
   onVariantChange() {
    var v = this.matchVariant();
    this.selected = v;
    if (v && this.idInput) this.idInput.value = v.id;
    if (v) {
     this.setSoldOut(!v.available);
     if (v.featured_media_id) {
      document.dispatchEvent(new CustomEvent('dox:variant:media', { detail: { mediaId: v.featured_media_id } }));
     }
     this.repriceBundles(v.id);
    } else {
     this.setSoldOut(true, true);
    }
    this.syncSelectedPrice();
   }
   repriceBundles(variantId) {
    var map = this.priceMap[String(variantId)];
    if (!map) return;
    this.bundleRadios.forEach((r) => {
     var entry = map[r.getAttribute('data-index')];
     if (!entry) return;
     r.setAttribute('data-price', entry.price || '');
     r.setAttribute('data-compare', entry.compare || '');
     r.setAttribute('data-saving', entry.saving || '');
     r.setAttribute('data-pct', entry.pct == null ? '' : entry.pct);
     var card = r.parentNode;
     var pEl = card.querySelector('[data-dox-b-price]');
     if (pEl && entry.price) pEl.textContent = entry.price;
     var cEl = card.querySelector('[data-dox-b-compare]');
     if (cEl) {
      var showC = this.compareOn && !!entry.compare;
      cEl.textContent = showC ? entry.compare : '';
      cEl.hidden = !showC;
     }
     var sEl = card.querySelector('[data-dox-b-saving]');
     if (sEl) {
      var showS = this.savingsOn && !!entry.saving;
      sEl.textContent = showS
       ? this.saveWord + ' ' + entry.saving + (entry.pct > 0 ? ' (' + entry.pct + '%)' : '')
       : '';
      sEl.hidden = !showS;
     }
    });
   }
   setSoldOut(soldOut, unavailable) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = !!soldOut;
    if (!this.btnText) return;
    if (unavailable) this.btnText.textContent = this.getStr('unavailable', 'Unavailable');
    else if (soldOut) this.btnText.textContent = this.getStr('soldOut', 'Sold out');
    else this.btnText.textContent = this.submitBtn.getAttribute('data-label') || this.getStr('addToCart', 'Add to cart');
   }
   getStr(key, fallback) {
    return (window.variantStrings && window.variantStrings[key]) || fallback;
   }
   selectedBundle() {
    return this.bundleRadios.filter((x) => x.checked)[0] || this.bundleRadios[0] || null;
   }
   syncSelectedPrice() {
    var r = this.selectedBundle();
    var price = r ? r.getAttribute('data-price') : '';
    var compare = r ? r.getAttribute('data-compare') : '';
    this.priceTargets.forEach((el) => { if (price) el.textContent = price; });
    this.compareTargets.forEach((el) => {
     if (compare && this.compareOn) { el.textContent = compare; el.hidden = false; el.style.display = ''; }
     else { el.textContent = ''; el.hidden = true; el.style.display = 'none'; }
    });
   }
   onBundleChange() {
    var r = this.selectedBundle();
    if (!r) return;
    var qty = parseInt(r.getAttribute('data-qty'), 10) || 1;
    if (this.qtyInput) this.qtyInput.value = qty;
    if (this.qtyDisplay) this.qtyDisplay.value = qty;
    if (this.bundleProp) this.bundleProp.value = r.getAttribute('data-label') || '';
    this.bundleRadios.forEach((br) => {
     var card = br.parentNode;
     var on = br.checked;
     card.classList.toggle('dox-bundle--active', on);
     var selects = card.querySelectorAll('[data-dox-bundle-theme]');
     for (var i = 0; i < selects.length; i++) selects[i].disabled = !on;
    });
    this.syncSelectedPrice();
   }

   /* Submit is deliberately NOT handled here. Horizon's
      <product-form-component> owns it, which keeps the cart drawer,
      checkout, analytics and fly-to-cart working. */

   showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.hidden = !msg;
    if (msg) this.errorEl.textContent = msg;
   }
  });
 }
})();